export default (function (_ref) {
  var request = _ref.request;
  return {
    labAreaAdd: function labAreaAdd(data) {
      return request({
        url: '/org/lab/area',
        method: 'post',
        data: data
      });
    },
    labAreaModify: function labAreaModify(data) {
      return request({
        url: "/org/lab/area/".concat(data.id),
        method: 'put',
        data: data
      });
    },
    labAreaDel: function labAreaDel(id) {
      return request({
        url: "/org/lab/area/".concat(id),
        method: 'delete'
      });
    },
    labAreaQuery: function labAreaQuery(data) {
      return request({
        url: '/org/lab/area',
        method: 'get',
        params: data
      });
    },
    labAreaTree: function labAreaTree() {
      return request({
        url: '/org/lab/area/tree',
        method: 'get'
      });
    },
    labAreaDetail: function labAreaDetail(id, params) {
      return request({
        url: "/org/lab/area/".concat(id),
        method: 'get',
        params: params
      });
    }
  };
});